import { component } from "picoapp";
import { getHeaderHeights } from "../../utilities/general";

export const sectionAnchoring = component((node: HTMLAnchorElement) => {
  const anchorSectionName = node.dataset.anchorSection;
  const anchorIndex = node.dataset.anchorIndex;
  if (!anchorIndex || !anchorSectionName) return;
  const sectionElement = document.querySelectorAll<HTMLElement>(
    ".shopify-section" + `.section-${anchorSectionName}`
  );
  const setScrollMargin = () => {
    sectionElement[
      parseInt(anchorIndex)
    ].style.scrollMarginTop = `${getHeaderHeights()}px`;
    document.documentElement.style.scrollBehavior = "smooth";
  };

  if (sectionElement) {
    const anchorSectionElement = sectionElement[parseInt(anchorIndex)];
    node.href = "#" + anchorSectionElement.id;
    node.addEventListener("click", setScrollMargin);
  }

  return () => {
    if (sectionElement) {
      node.removeEventListener("click", setScrollMargin);
    }
  };
});
